import { isValidPhoneNumber } from '@components/forms/components/ContactMethodForm';
import ServiceUser from '@modules/ServiceModule/workspace/types/ServiceUser';
import maskPhoneNumber from './maskPhoneNumber';

const getDisplayName = (
  displayName: string,
  isInternal: boolean,
  users: readonly ServiceUser[],
) => {
  if (displayName?.startsWith('+')) {
    return maskPhoneNumber(displayName);
  }

  const [phoneNumber] = displayName.split(' ');
  const maskedPhoneNumber = maskPhoneNumber(phoneNumber);

  if (maskedPhoneNumber && isValidPhoneNumber(maskedPhoneNumber)) {
    return maskedPhoneNumber;
  }

  if (!isInternal) {
    return displayName;
  }

  const contactCenterUserId = displayName
    .replace('User', '')
    .replace(/ *\([^)]*\) */g, '')
    .trim();

  const taskUser = users.find(
    (user) => user.contactCenterUserId === contactCenterUserId,
  );

  return taskUser?.name ?? displayName;
};

export default getDisplayName;
